import { distinctUntilChanged, Observable, pipe, UnaryFunction } from 'rxjs';

export function rxDistinctStringArrayChanged<T>(): UnaryFunction<
  Observable<T[]>,
  Observable<T[]>
> {
  return pipe(
    distinctUntilChanged(
      (a, b) =>
        a.length === b.length && a.every((id, index) => id === b[index]),
    ),
  );
}

/**
 * Distinct until the array changes by the field value
 * Usage:
 * ```ts
 * observable$.pipe(
 *   rxDistinctArrayByField((item) => item.id),
 * )
 * ```
 */
export function rxDistinctArrayByField<T, K>(
  field: (item: T) => K,
): UnaryFunction<Observable<T[]>, Observable<T[]>> {
  return pipe(
    distinctUntilChanged(
      (a, b) =>
        a.length === b.length &&
        a.every((item, index) => field(item) === field(b[index])),
    ),
  );
}
